import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Model } from 'src/app/models/model.model';
import { Plant } from 'src/app/models/plant.model';
import { Train } from 'src/app/models/train.model';
import { Unit } from 'src/app/models/unit.interface';
import { Stage } from 'src/app/models/stage.interface';
import { Hybrid } from 'src/app/models/hybrid.interface';
import { User } from 'src/app/models/user.model';
import { ModelsService } from 'src/app/services/models/models.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { TrainService } from 'src/app/services/trains/trains.service';
import { Warrantycondition } from 'src/app/models/warrantycondition.model';
import { warrantyconditionService } from 'src/app/services/warrantyconditions/warrantycondition.service';
import { WarrantyType } from 'src/app/models/warrantytype.interface';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-edit-warranty',
  templateUrl: './edit-warranty.component.html',
  styleUrls: ['./edit-warranty.component.scss'],
})
export class EditWarrantyComponent {
  public Wtypes: Array<WarrantyType> = [
    { Id: 0, Name: 'Feed Pressure' },
    { Id: 1, Name: 'Permeate TDS' },
  ];

  public stage: Array<Stage> = [
    { Id: 1, Name: '1' },
    { Id: 2, Name: '2' },
    { Id: 3, Name: '3' },
  ];

  WarrantyDetails: Warrantycondition = new Warrantycondition();
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private trainService: TrainService,
    private plantService: PlantsService,
    private warrantyconditionService: warrantyconditionService,
    private toastr: ToastrService
  ) { }
  trainDetails: Train = new Train();

  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  dateNow: Date = new Date();
  updateWarranty: Warrantycondition = new Warrantycondition();
  SelectedId: string;
  warrantyId: number;
  plants: Plant[] = [];
  plantDetails: Plant = new Plant();
  plantId: string;
  plantName: string = '';
  allTrainList: Train[] = [];
  DelwarrantyId: any;

  getSelectedId(e) {
   
    this.SelectedId = e.target.value;

    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.allTrainList = response;
        console.log(this.allTrainList);
      },

      (error: any) => {
        console.log('error list');
      }
    );
  }

  getSelectedTrain(e) {
    this.SelectedId = e.target.value;
    this.trainService.getTrainById(this.SelectedId).subscribe({
      next: (response) => {
        this.trainDetails = response;
        this.updateWarranty.Stage = this.trainDetails.Stages;
        console.log(this.trainDetails);
      },
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe({
      next: (params) => {
        const id = atob(params.get('id')!);
        
        this.warrantyId = +id;
        if (id) {
         
          this.warrantyconditionService.getwarrantiesById(id).subscribe({
            next: (response) => {
              this.WarrantyDetails = response;
              console.log(this.WarrantyDetails);

              // Get All Plant Names

              let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
              if (loggedInuserRole.role == 'Standard User') {
                this.plantService.getPlantsByUserId(loggedInuserRole.userId)
                  .subscribe({
                    next: (plants) => {
                      this.plants = plants;
                    },
                  })

              }
              else {
                this.plantService.getAllPlant().subscribe({
                  next: (plants) => {
                    this.plants = plants;
                  },
                  error: (response) => {
                    console.log(response);
                  },
                });
              }


              this.plantId = String(this.WarrantyDetails.PlantId);
              console.log(this.plantId);

              this.plantService.getPlant(this.plantId).subscribe({
                next: (response) => {
                  this.plantDetails = response;
                  console.log(this.plantDetails);
                },
              });

              this.trainService
                .getTrainByPlantId(this.plantId)
                .subscribe((response: Train[]) => {
                  this.allTrainList = response;
                  console.log(this.allTrainList);
                });
            },
          });
        }
      },
    });
  }

  updatewarranty() {
    const dateNowISO = this.dateNow.toISOString();

    this.WarrantyDetails.CreatedAt = dateNowISO;
    this.WarrantyDetails.UpdatedAt = dateNowISO;
    this.WarrantyDetails.Warrantycondition1 = 'test warranty';

    this.warrantyconditionService
      .updateWarranty(this.WarrantyDetails.Id, this.WarrantyDetails)
      .subscribe({
        next: (warrantycondition) => {
          console.log(this.WarrantyDetails);

          // alert(`Warranty condition updated successfully!`);
          this.toastr.success(
            'Warranty sondition Updated Successfully.',
            'Information'
          );
        },
      });
  }

  deletewarranty(id: number) {
    this.DelwarrantyId = id + '';
    const confirmDelete = confirm(
      'Are you sure you want to delete this Warranty?'
    );

    if (!confirmDelete) {
      return; // If the user clicks "Cancel" in the confirmation dialog, do nothing.
    }

    this.warrantyconditionService
      .deleteWarranty(this.DelwarrantyId)
      .subscribe((response: Response) => {
        if (response.statusText == 'Success') {
          this.toastr.error(
            'Warranty Condition deleted successfully.',
            'Information'
          );
          this.router.navigate(['/warrantycondition']);
        } else {
          (error) => {
            console.log('Error deleting Warranty Condition:', error);
          };
        }
      });
  }
}
